/* ================================================================
   NACHA MOVES — JS INTERACTIONS
   Subir como: assets/nacha-interactions.js
   Incluir desde theme.liquid (antes de </body>):
     <script src="{{ 'nacha-interactions.js' | asset_url }}" defer></script>
   ================================================================ */

(function(){
  'use strict';

  // ============== MODAL DE RESERVA ==============
  let reservaSelected = null;
  let reservaVariantId = null; // El variant_id del producto "clases presenciales" en Shopify

  window.NM = window.NM || {};

  window.NM.openReservaModal = function(classInfo, variantId) {
    reservaSelected = classInfo || null;
    reservaVariantId = variantId || null;
    const modal = document.getElementById('nm-reserva-modal');
    if (!modal) return;
    const tipoEl = document.getElementById('nm-reserva-tipo');
    const fechaEl = document.getElementById('nm-reserva-fecha');
    if (classInfo) {
      const parts = classInfo.split(' · ');
      if (tipoEl) tipoEl.textContent = parts[0] || 'Clase grupal';
      if (fechaEl) fechaEl.textContent = parts.slice(1).join(' · ') || 'Horario por confirmar';
    } else {
      if (tipoEl) tipoEl.textContent = 'Paquete de clases';
      if (fechaEl) fechaEl.textContent = 'Elige tu horario después del pago';
    }
    modal.classList.add('show');
  };

  window.NM.closeReservaModal = function() {
    const modal = document.getElementById('nm-reserva-modal');
    if (modal) modal.classList.remove('show');
  };

  /**
   * Agrega el paquete al carrito de Shopify con la clase reservada como line item property,
   * y redirige al checkout nativo.
   */
  window.NM.goToShopifyCheckout = function() {
    const select = document.getElementById('nm-reserva-paquete');
    if (!select) return;
    const selValue = select.value; // formato: "variantId|paqueteNombre"
    const [variantId, paqueteNombre] = selValue.split('|');
    if (!variantId) {
      alert('Selecciona un paquete antes de continuar.');
      return;
    }
    // Construir el form data para /cart/add.js
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (reservaSelected) {
      formData.append('properties[Clase reservada]', reservaSelected);
    }
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(r => r.json())
      .then(() => {
        // Redirigir al checkout
        window.location.href = '/checkout';
      })
      .catch(err => {
        console.error('Error agregando al carrito:', err);
        alert('Hubo un problema al procesar tu reserva. Intenta de nuevo o contacta soporte.');
      });
  };

  // ============== HEALTH FORM ==============
  window.NM.switchEtapa = function(etapa, btn) {
    document.querySelectorAll('.nm-etapa-toggle button').forEach(b => b.classList.remove('active'));
    if (btn) btn.classList.add('active');
    const pre = document.getElementById('nm-form-prenatal');
    const post = document.getElementById('nm-form-postnatal');
    if (pre) pre.style.display = etapa === 'prenatal' ? 'block' : 'none';
    if (post) post.style.display = etapa === 'postnatal' ? 'block' : 'none';
  };

  window.NM.setRadio = function(label, conditionalId) {
    const group = label.parentElement;
    group.querySelectorAll('label').forEach(l => l.classList.remove('checked'));
    label.classList.add('checked');
    const input = label.querySelector('input');
    if (input) input.checked = true;
    if (conditionalId) {
      const baseId = conditionalId.replace(/-si$|-no$/, '-detalle');
      const cond = document.getElementById(baseId);
      if (cond) {
        const isSi = conditionalId.endsWith('-si');
        cond.classList.toggle('show', isSi);
      }
    }
  };

  window.NM.toggleCheck = function(label) {
    const input = label.querySelector('input');
    if (!input) return;
    input.checked = !input.checked;
    label.classList.toggle('checked', input.checked);
  };

  window.NM.submitHealthForm = function(event, etapa) {
    event.preventDefault();
    // Recolectar datos del form
    const form = event.target;
    const data = {};
    form.querySelectorAll('input, select, textarea').forEach(el => {
      if (!el.name) return;
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (el.checked) {
          if (data[el.name]) data[el.name] += ', ' + (el.value || el.parentElement.textContent.trim());
          else data[el.name] = el.value || el.parentElement.textContent.trim();
        }
      } else if (el.value) {
        data[el.name] = el.value;
      }
    });
    data._etapa = etapa;
    console.log('Health form data:', data);
    // En producción: POST a un endpoint custom o app de form submission
    // Por ejemplo: Shopify metafields via Storefront API, o app Powerful Form Builder
    alert('¡Información guardada! ✓\n\nTus datos de salud (' + (etapa === 'prenatal' ? 'Pre natal' : 'Post natal') + ') están registrados de forma confidencial. Nacha los revisará antes de tu primera clase.\n\nTe enviamos un correo de confirmación.');
    window.location.href = '/';
  };

  // ============== FILTROS PROGRAMAS ==============
  window.NM.filterProgramas = function(btn, tag) {
    document.querySelectorAll('.nm-fpill').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.querySelectorAll('.nm-programas-listing .nm-prog-card').forEach(c => {
      if (tag === 'all') c.style.display = '';
      else c.style.display = (c.dataset.tags || '').includes(tag) ? '' : 'none';
    });
  };

  // ============== LANGUAGE SWITCHER (cuando se use Shopify Markets) ==============
  // El selector real usa <form action="/localization">; este JS es solo para abrir/cerrar el menú
  window.NM.toggleLangMenu = function(e) {
    e && e.stopPropagation();
    const menu = document.getElementById('nm-lang-menu');
    if (menu) menu.classList.toggle('open');
  };

document.addEventListener('click', () => {
    const menu = document.getElementById('nm-lang-menu');
    if (menu) menu.classList.remove('open');
  });

  // ============== MOBILE MENU (v6) ==============
  window.NM.toggleMobileMenu = function() {
    const panel = document.getElementById('nm-mobile-panel');
    const overlay = document.getElementById('nm-mobile-panel-overlay');
    const toggle = document.getElementById('nm-mobile-toggle');
    if (!panel || !overlay) return;
    const isOpen = panel.classList.toggle('open');
    overlay.classList.toggle('open', isOpen);
    if (toggle) {
      toggle.classList.toggle('open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  };
  // ESC cierra el menú mobile
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const panel = document.getElementById('nm-mobile-panel');
      if (panel && panel.classList.contains('open')) window.NM.toggleMobileMenu();
    }
  });

  // ============== FAQ TABS + COLAPSO (v5) ==============
  window.NM.showFaqGroup = function(button, group) {
    const tabs = button.parentElement.querySelectorAll('.nm-faq-tab');
    tabs.forEach(t => t.classList.remove('active'));
    button.classList.add('active');
    document.querySelectorAll('.nm-faq-group').forEach(g => g.classList.remove('active'));
    const target = document.getElementById('nm-faq-' + group);
    if (target) target.classList.add('active');
  };
  window.NM.toggleFaq = function(qEl) {
    if (qEl && qEl.parentElement) qEl.parentElement.classList.toggle('collapsed');
  };

  // ============== ANIMACIÓN DE KPIs (count-up al hacer scroll) ==============
  function parseKPIValue(text) {
    // Extrae número y prefijo/sufijo: "+1,200" → {prefix:"+", num:1200, suffix:""}
    const match = String(text).match(/^([^\d-]*)([\d,.\-]+)(.*)$/);
    if (!match) return null;
    const prefix = match[1];
    const numStr = match[2].replace(/,/g, '');
    const num = parseFloat(numStr);
    const suffix = match[3];
    if (isNaN(num)) return null;
    return { prefix, num, suffix };
  }
  function animateKPI(el) {
    if (el.dataset.animated) return;
    el.dataset.animated = '1';
    const parsed = parseKPIValue(el.textContent);
    if (!parsed) return;
    const target = parsed.num;
    const duration = 1400;
    const start = performance.now();
    function tick(now) {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      const current = Math.floor(target * eased);
      el.textContent = parsed.prefix + current.toLocaleString('en-US') + parsed.suffix;
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = parsed.prefix + target.toLocaleString('en-US') + parsed.suffix;
    }
    requestAnimationFrame(tick);
  }
  function initKPIObserver() {
    if (!('IntersectionObserver' in window)) return;
    const els = document.querySelectorAll('.nm-kpi-num, .nm-hero-stat strong');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) animateKPI(entry.target);
      });
    }, { threshold: 0.3 });
    els.forEach(el => io.observe(el));
  }

  // ============== STICKY CTA (aparece tras scroll en páginas key) ==============
  function initStickyCTA() {
    const sticky = document.querySelector('.nm-sticky-cta');
    if (!sticky) return;
    let visible = false;
    function update() {
      const shouldShow = window.scrollY > 600;
      if (shouldShow !== visible) {
        visible = shouldShow;
        sticky.classList.toggle('show', visible);
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ============== SEARCH OVERLAY (predictive con AJAX nativo de Shopify) ==============
  window.NM.openSearch = function(e) {
    e && e.preventDefault();
    const overlay = document.getElementById('nm-search-overlay');
    if (!overlay) return;
    overlay.classList.add('show');
    const input = overlay.querySelector('input[type="search"]');
    if (input) setTimeout(() => input.focus(), 50);
  };
  window.NM.closeSearch = function() {
    const overlay = document.getElementById('nm-search-overlay');
    if (overlay) overlay.classList.remove('show');
  };

  function initPredictiveSearch() {
    const input = document.querySelector('#nm-search-overlay input[type="search"]');
    if (!input) return;
    const results = document.getElementById('nm-search-results');
    let timer = null;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        if (results) results.innerHTML = '';
        return;
      }
      timer = setTimeout(() => {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=8')
          .then(r => r.json())
          .then(data => {
            if (!results) return;
            const products = (data.resources?.results?.products) || [];
            const pages = (data.resources?.results?.pages) || [];
            const articles = (data.resources?.results?.articles) || [];
            const all = [...products, ...pages, ...articles];
            if (all.length === 0) {
              results.innerHTML = '<p style="padding:24px; font-family:var(--font-serif); color:var(--nm-text-muted); text-align:center;">Sin resultados para "' + q + '"</p>';
              return;
            }
            results.innerHTML = all.map(item => {
              const img = item.image ? `<img src="${item.image}" alt="" style="width:48px; height:48px; object-fit:cover; border-radius:6px; flex-shrink:0;">` : '';
              return `<a href="${item.url}" style="display:flex; gap:14px; align-items:center; padding:12px 16px; border-bottom:1px solid rgba(0,0,0,0.06); color:var(--nm-text); text-decoration:none;">
                ${img}
                <div style="flex:1; min-width:0;">
                  <div style="font-family:var(--font-display); font-weight:600; font-size:14px; text-transform:uppercase; letter-spacing:0.02em;">${item.title}</div>
                  ${item.price ? `<div style="font-family:var(--font-serif); font-size:13px; color:var(--nm-blue); margin-top:2px;">${item.price}</div>` : ''}
                </div>
              </a>`;
            }).join('');
          });
      }, 200);
    });
  }

  // ============== INIT ==============
  document.addEventListener('DOMContentLoaded', () => {
    // Click fuera del modal para cerrar
    const overlay = document.getElementById('nm-reserva-modal');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) window.NM.closeReservaModal();
      });
    }
    const searchOverlay = document.getElementById('nm-search-overlay');
    if (searchOverlay) {
      searchOverlay.addEventListener('click', (e) => {
        if (e.target === searchOverlay) window.NM.closeSearch();
      });
    }
    initKPIObserver();
    initStickyCTA();
    initPredictiveSearch();
  });

})();

// ============== v3 — NAV SCROLL-AWARE + HERO CAROUSEL ==============
(function() {
  const nav = document.querySelector('.nm-nav');
  const promo = document.querySelector('.nm-promo-bar');
  if (!nav) return;
  let lastY = window.scrollY;
  let ticking = false;
  function onScroll() {
    const y = window.scrollY;
    // scrolled state (solid white bg)
    if (y > 60) nav.classList.add('scrolled'); else nav.classList.remove('scrolled');
    // promo bar: SOLO visible al tope absoluto
    if (promo) {
      if (y <= 5) promo.classList.remove('hidden');
      else promo.classList.add('hidden');
    }
    // nav: hide on scroll-down (>100px), show on scroll-up
    if (y > lastY && y > 100) nav.classList.add('hidden');
    else if (y < lastY) nav.classList.remove('hidden');
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function() {
    if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
  onScroll();
})();

// Hero carousel (auto-advance 6s + clicks)
(function() {
  const dots = document.querySelectorAll('.nm-hero-dot');
  const bg = document.querySelector('.nm-hero-bg');
  if (!dots.length || !bg) return;
  let current = 0;
  function show(i) {
    current = i;
    bg.style.backgroundImage = `url('${dots[i].dataset.img}')`;
    dots.forEach((d, j) => d.classList.toggle('active', j === i));
  }
  dots.forEach((d, i) => d.addEventListener('click', () => show(i)));
  setInterval(() => show((current + 1) % dots.length), 6000);
})();
// ============== v3 FASE 2 — RESERVA MODAL + CALENDAR FILTER + TIPOS ACCORDION ==============

// ---- Reserva Modal (con cart.add real para checkout Shopify) ----
window.NM = window.NM || {};
window.NM.currentVariantId = null;

window.NM.openReservaModal = function(claseName, fecha, hora, variantId) {
  const modal = document.getElementById('nm-reserva-modal');
  if (!modal) return;
  document.getElementById('nm-reserva-modal-title').textContent = claseName;
  document.getElementById('nm-reserva-modal-date').textContent = fecha;
  document.getElementById('nm-reserva-modal-time').textContent = hora;
  window.NM.currentVariantId = variantId || null;
  modal.classList.add('show');
  document.body.style.overflow = 'hidden';
};

window.NM.closeReservaModal = function() {
  const modal = document.getElementById('nm-reserva-modal');
  if (modal) modal.classList.remove('show');
  document.body.style.overflow = '';
};

window.NM.submitReserva = function(event) {
  event.preventDefault();
  const form = event.target;
  const btn = form.querySelector('.nm-reserva-modal-cta');
  const nombre = form.querySelector('[name="nombre"]')?.value || '';
  const email = form.querySelector('[name="email"]')?.value || '';
  const telefono = form.querySelector('[name="telefono"]')?.value || '';
  const tipoAlumna = form.querySelector('[name="tipo_alumna"]')?.value || '';
  const claseInfo = document.getElementById('nm-reserva-modal-title').textContent + ' · ' +
                    document.getElementById('nm-reserva-modal-date').textContent + ' · ' +
                    document.getElementById('nm-reserva-modal-time').textContent;

  if (!window.NM.currentVariantId) {
    alert('Esta clase no tiene producto Shopify asociado. Configúrala en el theme editor.');
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Procesando...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: window.NM.currentVariantId,
      quantity: 1,
      properties: {
        'Clase': claseInfo,
        'Nombre': nombre,
        'Email': email,
        'Teléfono': telefono,
        'Tipo de alumna': tipoAlumna
      }
    })
  })
  .then(r => r.json())
  .then(data => {
    if (data.id) window.location.href = '/checkout';
    else { btn.disabled = false; btn.innerHTML = 'Confirmar reserva <span class="nm-arrow">→</span>'; alert('Error al reservar. Intenta de nuevo.'); }
  })
  .catch(err => { btn.disabled = false; btn.innerHTML = 'Confirmar reserva <span class="nm-arrow">→</span>'; alert('Error de conexión.'); console.error(err); });
};

// ESC + click outside cierra el modal
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const modal = document.getElementById('nm-reserva-modal');
    if (modal && modal.classList.contains('show')) window.NM.closeReservaModal();
  }
});
document.addEventListener('click', function(e) {
  const modal = document.getElementById('nm-reserva-modal');
  if (e.target === modal) window.NM.closeReservaModal();
});

// ---- Calendar filter (Pre/Post · Hipopresivos · Todas) ----
window.NM.filterCalendar = function(button, tipo) {
  document.querySelectorAll('.nm-cal-fpill').forEach(p => p.classList.remove('active'));
  button.classList.add('active');
  document.querySelectorAll('.nm-week-class').forEach(cls => {
    const cellTipo = cls.getAttribute('data-tipo');
    if (tipo === 'all') cls.classList.remove('filtered-out');
    else if (!cellTipo || cellTipo !== tipo) cls.classList.add('filtered-out');
    else cls.classList.remove('filtered-out');
  });
};

// ---- Tipos accordion toggle ----
window.NM.toggleTipo = function(headEl) {
  headEl.parentElement.classList.toggle('collapsed');
};
// ============== v3 FASE 3 — PROGRAMS CAROUSEL ==============
(function() {
  let progSlide = 0;
  const progSlidesTotal = 3; // 9 cards / 3 per slide
  
  window.NM = window.NM || {};
  
  function updateProgCarousel() {
    const track = document.getElementById('nm-prog-carousel-track');
    const prevBtn = document.getElementById('nm-prog-carousel-prev');
    const nextBtn = document.getElementById('nm-prog-carousel-next');
    const dots = document.querySelectorAll('#nm-prog-carousel-dots button');
    if (!track) return;
    const wrap = track.parentElement;
    const slideWidth = wrap.offsetWidth;
    track.style.transform = `translateX(-${progSlide * (slideWidth + 20)}px)`;
    if (prevBtn) prevBtn.disabled = progSlide === 0;
    if (nextBtn) nextBtn.disabled = progSlide === progSlidesTotal - 1;
    dots.forEach((d, i) => d.classList.toggle('active', i === progSlide));
  }
  
  window.NM.moveProgCarousel = function(direction) {
    const newSlide = progSlide + direction;
    if (newSlide < 0 || newSlide >= progSlidesTotal) return;
    progSlide = newSlide;
    updateProgCarousel();
  };
  
  window.NM.goToProgSlide = function(i) {
    progSlide = i;
    updateProgCarousel();
  };
  
  window.addEventListener('resize', updateProgCarousel);
  // Initial setup después de carga
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(updateProgCarousel, 50));
  } else {
    setTimeout(updateProgCarousel, 50);
  }
})();
// ============== v3 FASE 4 — Subscription popup + FAQ flat toggle ==============
window.NM = window.NM || {};

window.NM.closeSubPopup = function() {
  const popup = document.getElementById('nm-sub-popup');
  if (popup) popup.classList.remove('show');
};

window.NM.submitSubPopup = function(event) {
  event.preventDefault();
  alert('¡Gracias! Te enviamos un correo con el acceso a tu primera clase gratis.');
  window.NM.closeSubPopup();
};

window.NM.toggleFaqFlat = function(qEl) {
  if (qEl && qEl.parentElement) qEl.parentElement.classList.toggle('collapsed');
};

// Auto-show popup después de 5s (solo una vez por sesión)
(function() {
  if (sessionStorage.getItem('nm-sub-shown')) return;
  setTimeout(() => {
    const popup = document.getElementById('nm-sub-popup');
    if (popup) {
      popup.classList.add('show');
      sessionStorage.setItem('nm-sub-shown', '1');
    }
  }, 5000);
})();
/* ============================================================
   Detecta páginas sin hero y fuerza header sólido
   ============================================================ */
(function(){
  function applyHeaderMode(){
    var nav = document.querySelector('.nm-nav');
    if (!nav) return;
    var path = (location.pathname || '').toLowerCase();
    var noHeroPaths = ['/apps/ldt-course', '/account', '/customer_authentication', '/authentication', '/policies', '/blogs'];
    var isNoHero = noHeroPaths.some(function(p){ return path.indexOf(p) === 0; });
    var hasHero = !!document.querySelector('.nm-hero, .nm-page-hero, .nm-hero-home');
    if (isNoHero || !hasHero) {
      nav.classList.add('no-hero-page');
      document.body.classList.add('nm-no-hero-body');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeaderMode);
  } else {
    applyHeaderMode();
  }
})();
/* ============================================================
   Footer accordion en mobile — toggle por columna
   ============================================================ */
(function(){
  function initFooterAccordion(){
    if (window.innerWidth > 768) return;
    document.querySelectorAll('.nm-foot-col h4').forEach(function(h4){
      if (h4.dataset.accordionInit) return;
      h4.dataset.accordionInit = '1';
      h4.addEventListener('click', function(){
        var col = h4.parentElement;
        col.classList.toggle('open');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
  // Re-init en resize por si cambia de desktop a mobile
  var resizeT;
  window.addEventListener('resize', function(){
    clearTimeout(resizeT);
    resizeT = setTimeout(initFooterAccordion, 200);
  });
})();
/* ============================================================
   Footer accordion en mobile — event delegation (más robusto)
   ============================================================ */
document.addEventListener('click', function(e){
  if (window.innerWidth > 768) return;
  var h4 = e.target.closest('.nm-foot-col h4');
  if (h4) {
    e.preventDefault();
    var col = h4.parentElement;
    col.classList.toggle('open');
  }
});
